import { InterpolationWithTheme } from "@emotion/core";
import { Dictionary } from "lodash";
import { colors } from "../colors";

const mqMobile = "@media only screen and (max-width: 768px)";
export const interventionsHistoryStyles: Dictionary<InterpolationWithTheme<any>> = {
    table: {
        width: "100%",
    },
    tableHeader: {
        color: "rgb(51, 94, 144)",
        fontFamily: "BrandonTextWeb-Medium",
        fontSize: 14,
        fontWeight: 500,

        [mqMobile]: {
            padding: "0 20px",
            marginBottom: 20
        }
    },
    tableBodyText: {
        color: "rgb(51, 51, 51)",
        fontFamily: "BrandonTextWeb-Regular",
        fontSize: 14,
        fontWeight: "normal"
    },
    colData: {
        margin: "10px 0px",
        [mqMobile]: {
            margin: 0,
            padding: "10px 0px 10px 20px"
        }
    },
    paddedTd: {
        padding: "0px 33px"
    },
    legendContainer: {
        display: "flex",
        justifyContent: "center",
        padding: 14,
        //borderTop: "2px solid rgb(182,198,215)"
    },
    prevNextBtn: {
        color: "#ff316d",
        fontFamily: "BrandonTextWeb-Medium",
        fontSize: 12,
        fontWeight: 500,
        cursor: "pointer"
    },
    caratStyles: {
        fontSize: 10,
        marginLeft: 5,
        cursor: "pointer"
    },
    selectedTab: {
        display: "inline-block",
        padding: "10px 10px 10px 7px",
        background: "#ffffff",
        width: 190,
        margin: 0,
        position: "relative",
        top: 5,
        left: 0,
        textAlign: 'center',
        color: "rgb(255, 49, 109)",
        fontFamily: "BrandonTextWeb-Medium",
        fontSize: 16,
        fontWeight: 500,
        borderRadius: "9px 9px 0px 0px"
    },
    paginationText: {
        margin: "0 10px"
    },
    //mobile designs
    historyViewContainer: {
        display: "flex"
    },
    leftContainer: {
        width: "50%",
        zIndex: 999
    },
    rightContainer: {
        width: "50%"
    },
    middleContainer: {
        width: "6%",
        top: "40px",
        position: "relative",
        height: 0
    },
    activityList: {
        boxShadow: "5px 0px 13px -5px #aaaaaa",
        minHeight: "157px",
        paddingBottom: "35px"
    },
    columnHeader: {
        color: "rgb(51, 94, 144)",
        fontFamily: "BrandonTextWeb-Medium",
        fontSize: 14,
        marginBottom: 20
    },
    historyCardWrapper: {
        margin: 20,
        borderRadius: 10,
        overflow: 'hidden',
        [mqMobile]: {
            margin: "20px 0px",
            paddingBottom: 40
        }
    },
    slideItemWrapper: {
        textAlign: "center"
    }
}
